<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      icon="flash_on"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row>
        <v-card
          class="mt-5 mx-5 pa-10"
          tile
        >
          <h2>Privacy Policy </h2>
          <v-container>
            <p>
              Effettuando la prenotazione confermate di aver letto, ed accettato tutti i termini e condizioni contenuti in questa pagina,<br>
              e ci autorizzate a memorizzare, elaborare ed utilizzare i dati forniti per i seguenti scopi:
            </p>
            <v-container>
              <h3>Uso ai fini gestione ed evasione Prenotazione</h3>
              <ol>
                <li class="my-1">
                  <strong>DEMO</strong> potrà elaborare manualmente o tramite procedure informatizzate i dati forniti al fine di evadere al meglio la richiesta ricevuta.
                </li>
                <li class="my-1">
                  <strong>DEMO</strong> potrà inoltre inviare notifiche a mezzo SMS o WhatsApp o altra piattaforma per confermare, modificare o cancellare una prenotazione.
                </li>
                <li class="my-1">
                  <strong>DEMO</strong> potrà utilizzare i dati forniti per elaborare statistiche, previsioni e ogni altro strumento utile o necessario a gestire al meglio la propria attività.
                </li>
                <li class="my-1">
                  Ogni utente potrà autonomamente ed in qualsiasi momento cancellare i dati sensibili (nome e numero whatsapp) accedendo tramite il link che gli verrà fornito a prenotazione confermata
                </li>
              </ol>
              <h3>Conservazione dei dati</h3>
              <ol>
                <li class="my-1">
                  <strong>DEMO</strong> potrà comunque conservare ed utilizzare i dati non sensibili, in forma aggregata ai fini statistici.
                </li>
              </ol>
              <h3>Uso con finalità di Marketing</h3>
              <ol>
                <li class="my-1">
                  <strong>DEMO</strong> potrà utilizzare, in collaborazione con i suoi partner commerciali e tecnologici i dati forniti per finalità promozionali, di marketing e di customer satisfaction:
                  <br> I dati non saranno venduti, ceduti o forniti a terzi, ne a titolo gratuito ne a titolo oneroso per qualsiasi altro fine
                </li>                
              </ol>              
            </v-container>
            <v-divider></v-divider>
            <h2 class="mt-5">Cookies</h2>
            <v-container>
              <p>
                <strong>DEMO</strong> può utilizzare sistemi di profilazione facenti riferimento a Facebook/Google/Instagram ed altri Social Networks sia basati su cookies che su altre tecnologie.
              </p>
            </v-container>
          </v-container>
        </v-card>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: "Privacy Policy",
      breadcrumbs: [
        {
          text: "Privacy Policy & Limited Use Requirements Disclosure",
          disabled: true,
        },
      ],
    };
  },
};
</script>